import * as React from "react";

function Add(props: React.SVGProps<SVGSVGElement>) {
  return <svg width={18} height={18} viewBox="0 0 18 18" fill="currentColor" {...props}><path fillRule="evenodd" d="M10,8 L13.5,8 C13.7761424,8 14,8.22385763 14,8.5 L14,9.5 C14,9.77614237 13.7761424,10 13.5,10 L10,10 L10,13.5 C10,13.7761424 9.77614237,14 9.5,14 L8.5,14 C8.22385763,14 8,13.7761424 8,13.5 L8,10 L4.5,10 C4.22385763,10 4,9.77614237 4,9.5 L4,8.5 C4,8.22385763 4.22385763,8 4.5,8 L8,8 L8,4.5 C8,4.22385763 8.22385763,4 8.5,4 L9.5,4 C9.77614237,4 10,4.22385763 10,4.5 L10,8 Z" fill="" /></svg>;
}

export default Add;